import { useApp } from "@/context/AppContext";
import { Editable } from "@/components/Editable";
import { Radio, Youtube, ExternalLink } from "lucide-react";

function toEmbed(url) {
  if (!url) return null;
  const yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|live\/))([\w-]+)/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}?autoplay=0`;
  return url;
}

export default function LiveTV() {
  const { ov, t } = useApp();
  const embedUrl = ov("media.livetv_url") || "https://www.youtube.com/embed/live_stream?channel=UC4R8DWoMoI7CAwX8_LjQHig";
  const channelUrl = ov("media.channel_url") || "https://www.youtube.com/@oojjascorporate";
  const embed = toEmbed(embedUrl);

  return (
    <section className="oj-section bg-[#0B3B39]" data-testid="live-tv">
      <div className="oj-container grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
        <div className="lg:col-span-2">
          <div className="relative rounded-2xl overflow-hidden border border-amber-400/30 shadow-2xl aspect-video bg-black">
            <span className="absolute top-3 left-3 z-10 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-red-600 text-white text-[11px] font-bold uppercase tracking-wider"><Radio className="w-3.5 h-3.5 animate-pulse" /> {t.hub.liveBadge}</span>
            <iframe src={embed} title="OOJJAS Live TV" className="w-full h-full" allow="autoplay; encrypted-media; fullscreen" allowFullScreen />
          </div>
        </div>
        <div>
          <div className="oj-eyebrow mb-3 !text-amber-300"><Youtube className="w-4 h-4" /> {t.hub.broadcastNet}</div>
          <Editable as="h2" id="media.livetv_title" className="text-2xl sm:text-3xl font-extrabold text-white block">{t.hub.liveTvTitle}</Editable>
          <Editable as="p" id="media.livetv_desc" className="mt-4 text-teal-100/80 leading-relaxed block">{t.hub.liveTvDesc}</Editable>
          <div className="mt-5 space-y-3">
            <div className="oj-card !bg-white/5 !border-white/15 p-3 text-xs text-teal-100/70">
              <div className="font-mono uppercase tracking-wider text-amber-300 mb-1">{t.hub.streamUrl}</div>
              <Editable id="media.livetv_url" className="break-all text-teal-100/90">{embedUrl}</Editable>
            </div>
            <a href={channelUrl} target="_blank" rel="noreferrer" className="oj-btn-gold w-full" data-testid="channel-link"><Youtube className="w-4 h-4" /> {t.hub.visitChannel} <ExternalLink className="w-4 h-4" /></a>
            <div className="oj-card !bg-white/5 !border-white/15 p-3 text-xs text-teal-100/70">
              <div className="font-mono uppercase tracking-wider text-amber-300 mb-1">{t.hub.channelLink}</div>
              <Editable id="media.channel_url" className="break-all text-teal-100/90">{channelUrl}</Editable>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
